import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import { getInvoices } from "../helpers/Invoices";
import { Link } from "react-router-dom";
import { format } from "../helpers/Currency";
import Pagination from "../components/Pagination";
import { getProducts } from "../helpers/Products";
import { getStores } from "../helpers/Stores";


export default function Stores() {
    const { appState } = useAppState();
    const [stores, setStores] = useState<Array<any>>([])
    const [search, setSearch] = useState<string | null>(null)
    const [page, setPage] = useState<number>(1)
    const [meta, setMeta] = useState<any>({
        page: 1,
        totalPages: 1,
    });

    useEffect(() => {
        getStores(10, page, search).then((result) => {
            setStores(result.data)
            setMeta({
                page: result.current_page,
                totalPages: result.last_page,
            })
        })
    }, [page, search])

    useEffect(() => {
        setPage(1);
    }, [search])

    return (
        <>
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-xl">Stores</h1>
                    <input onChange={(event) => { setSearch(event.target.value) }}></input>
                </div>
                <Link to="/stores/create" className="px-4 py-2 bg-blue-500 text-white rounded">Create Store</Link>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <table className="w-full">
                    <thead className="text-left">
                        <tr className="border-b-1">
                            <th className="p-2">Id</th>
                            <th className="p-2">Name</th>
                            <th className="p-2">URL</th>
                            <th className="p-2 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stores.map((store: any) => {
                            return (
                                <tr className="border-b-1 border-gray-300">
                                    <td className="p-2">
                                        <Link to={`/stores/${store.id}`}>{store.id}</Link>
                                    </td>
                                    <td className="p-2">{store.name}</td>
                                    <td className="p-2">{store.url}</td>
                                    <td className="p-2 ">
                                        <ul className="flex justify-end gap-x-2">
                                            <li>
                                                {/* <Link to={`/invoices/${invoice.id}`}>View</Link> */}
                                            </li>
                                            <li>
                                                {/* <a target="_blank" href={invoice.payment_link}>Link</a> */}
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {stores && stores.length > 0 ? (
                <div className="w-full mt-5">
                    <Pagination page={meta.page} totalPages={meta.totalPages} onCallback={setPage} />
                </div>
            ) : null}

        </>
    );
}
